import React from 'react';
import { commonStyles } from '../../styles/common';
import SectionHeading from '../ui/SectionHeading';
import ProcessStep from '../ui/ProcessStep';
import { processSteps } from '../../data/process';

const Process = () => {
  return (
    <section className={`${commonStyles.section} bg-gray-50`} id="process">
      <div className={commonStyles.container}>
        <SectionHeading
          title="Un processus simple et efficace"
          description="De l'audit initial jusqu'aux économies réalisées, nous vous accompagnons à chaque étape."
          centered
        />
        
        <div className="relative mt-16">
          <div className="absolute top-1/2 left-0 w-full h-0.5 bg-blue-200 -translate-y-1/2 hidden md:block" />
          
          <div className="grid md:grid-cols-5 gap-8">
            {processSteps.map((step, index) => (
              <ProcessStep key={step.title} step={step} index={index} />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Process;